import { render, staticRenderFns } from "./_forgotPassword.vue?vue&type=template&id=2fbe45f0&lang=pug&"
import script from "./_forgotPassword.vue?vue&type=script&lang=js&"
export * from "./_forgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports